import { render } from "./accountManage.vue?vue&type=template&id=4b969479&scoped=true"
import script from "./accountManage.vue?vue&type=script&lang=js"
export * from "./accountManage.vue?vue&type=script&lang=js"

import "./accountManage.vue?vue&type=style&index=0&id=4b969479&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b969479"]])

export default __exports__